<template>
  <div class="hello">
    <div>
      <ul class="cb">
        <li class="cbItem" @click="toggleRFQModal">
          <div class="cbTc cbTc1">
            <div class="cbTcEr"></div>
          </div>
          <a href="javascript:;" rel="nofollow"><img src="https://en.icqqg.com/assets/images/xunjia.png" class="slide-img"></a>
          <span>RFQ</span>
        </li>
        <li class="cbItem" id="cbItem0" @click="trackEvent('AW-16678313103/ZjJYCNuyuOEZEI-565A-')">
          <a :href="'mailto:'+setting.email" rel="nofollow"><img src="https://en.icqqg.com/assets/images/emals.png" class="slide-img"></a>
          <span>Email</span>
        </li>
        <li class="cbItem" id="cbItem1" :class="{ 'on': isWhatsappQRCodeVisible }" @click="handleContactClick('whatsapp')">
          <div class="cbTc cbTc-whatsapp" v-show="isWhatsappQRCodeVisible" style="width: 210px">
            <img :src="'https://en.icqqg.com/uploads/'+setting.whatsapp_qrcode" />
            <div style="font-size: 14px; color: black; text-align: center;background-color: white;">{{ setting.whatsapp }}</div>
          </div>
          <a href="javascript:;" rel="nofollow"><img src="https://en.icqqg.com/assets/images/mob/whatsapps.png" class="slide-img"></a>
          <span>Whatsapp</span>
        </li>
        <li class="cbItem" id="cbItem2" :class="{ 'on': isWechatQRCodeVisible }" @click="handleContactClick('wechat')">
          <div class="cbTc cbTc-wechat" v-show="isWechatQRCodeVisible" style="width: 210px">
            <img :src="'https://en.icqqg.com/uploads/'+setting.wx_qrcode" />
            <div style="font-size: 14px; color: black; text-align: center;background-color: white;">{{ setting.wechat }}</div>
          </div>
          <a href="javascript:;" rel="nofollow"><img src="https://en.icqqg.com/assets/images/mob/n2.png" class="slide-img"></a>
          <span>Wechat</span>
        </li>
        <li class="cbItem" id="cbItem4" :class="{ 'on': isTelegramQRCodeVisible }" @click="handleContactClick('telegram')">
          <div class="cbTc cbTc-telegram" v-show="isTelegramQRCodeVisible" style="width: 210px">
            <img src="https://en.icqqg.com/assets/images/mob/telegram_qrcode.png" />
            <div style="font-size: 14px; color: black; text-align: center;background-color: white;">+86 19166251823</div>
          </div>
          <a href="javascript:;" rel="nofollow"><img src="https://en.icqqg.com/assets/images/telegram.png" class="slide-img"></a>
          <span>Telegram</span>
        </li>
        <li class="cbItem" id="cbItem3" :class="{ 'on': isLineQRCodeVisible }" @click="handleContactClick('line')">
          <div class="cbTc cbTc-line" v-show="isLineQRCodeVisible" style="width: 210px">
            <img :src="'https://en.icqqg.com/uploads/'+setting.line_qrcode" />
            <div style="font-size: 14px; color: black; text-align: center;background-color: white;">{{ setting.line }}</div>
          </div>
          <a href="javascript:;" rel="nofollow"><img src="https://en.icqqg.com/assets/images/mob/line.png" class="slide-img"></a>
          <span>Line</span>
        </li>
        <li class="cbItem">
          <div class="cbTc">
            <div class="cbTcTel"></div>
          </div>
          <a href="javascript:;" rel="nofollow" @click.prevent="scrollToTop"><img class="slide-img" src="https://en.icqqg.com/assets/images/top.png"></a>
        </li>
      </ul>
    </div>

    <!-- RFQ Modal -->
    <!-- <b-modal v-model="isRFQModalVisible" title="RFQ" hide-footer dialog-class="modal-center">
      <form @submit.prevent="submitRFQ">
        <div class="form-group">
          <label class="form-label" for="rfq-product">Product<span style="color: red;"> *</span></label>
          <input
            id="rfq-product"
            type="text"
            v-model="rfqForm.product"
            class="form-control"
            placeholder="Enter product name"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label" for="rfq-num">Quantity<span style="color: red;"> *</span></label>
          <input
            id="rfq-num"
            type="number"
            v-model="rfqForm.num"
            class="form-control"
            placeholder="Enter the required quantity"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label" for="rfq-email">Email<span style="color: red;"> *</span></label>
          <input
            id="rfq-email"
            type="email"
            v-model="rfqForm.email"
            class="form-control"
            placeholder="Enter your email"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label" for="rfq-company">Company</label>
          <input
            id="rfq-company"
            type="text"
            v-model="rfqForm.company"
            class="form-control"
            placeholder="Enter your company name"
          />
        </div>

        <div class="d-flex justify-content-around mt-4">
          <button style="background-color: red;color: white;" type="button" class="btn btn-red" @click="isRFQModalVisible = false">Close</button>
          <button type="submit" class="btn btn-primary">Submit</button>
        </div>

        <p style="color: red; font-size: 14px; margin-top: 20px;">
          We will reply to you through your email address as soon as we receive your RFQ.
        </p>
      </form>
    </b-modal> -->
    <!-- Quote Modal -->
    <div style="background-color: rgba(0, 0, 0, 0.5);" class="modal" tabindex="-1" :class="{ 'd-block': isRFQModalVisible }" v-if="isRFQModalVisible">
      <div class="modal-dialog" style="margin-top: 240px;">
        <div class="modal-content">
          <button type="button" class="btn-close" @click="isRFQModalVisible = false"></button>
          <div class="modal-header">
            <h5 class="modal-title">Quote</h5>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitQuote">
              <div class="mb-3">
                <div class="form-groups">
                  <div class="form-labels">Partnum *</div>
                  <div class="form-control-wraps"><input type="text" class="form-control" v-model="quoteForm.name" :readonly="product"></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="form-groups">
                  <div class="form-labels">Qty *</div>
                  <div class="form-control-wraps"><input type="number" class="form-control" v-model="quoteForm.num" min="1"></div>
                </div>
              </div>
              <div class="mb-4">
                <div class="form-groups">
                  <div class="form-labels">Email *</div>
                  <div class="form-control-wraps"><input type="text" class="form-control" v-model="quoteForm.email"></div>
                </div>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-primary form-submit-btn">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Popup -->
    <div class="contact-popup" v-if="isContactPopupVisible">
      <div class="popup-content">
        <div class="popup-header">
          <button type="button" class="close-btn" @click="isContactPopupVisible = false">×</button>
        </div>
        <div class="popup-body">
          <div v-if="currentContactType !== 'email'" class="qrcode">
            <img :src="currentQRCode" alt="QR Code" />
          </div>
          <div class="contact-info">{{ currentContact }}</div>
          <div class="instruction-text">
            <template v-if="currentContactType === 'whatsapp'">
              Open WhatsApp, paste in the search box and search
            </template>
            <template v-else-if="currentContactType === 'wechat'">
              Open WeChat, paste in the search box and search
            </template>
            <template v-else-if="currentContactType === 'telegram'">
              Open Telegram, paste in the search box and search
            </template>
            <template v-else-if="currentContactType === 'line'">
              Open Line, paste in the search box and search
            </template>
            <template v-else-if="currentContactType === 'email'">
              Open Email, paste in the address field
            </template>
          </div>
          <div class="extra-text">We will give you a quotation</div>
          <button class="know-btn" @click="isContactPopupVisible = false">I know</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/api';
export default {
  name: 'HelloWorld',
  props: {
    msg: String,
    product: String,
  },
  data() {
    return {
      isWechatQRCodeVisible: false,
      isWhatsappQRCodeVisible: false,
      isTelegramQRCodeVisible: false,
      isLineQRCodeVisible: false,
      isRFQModalVisible: false, // Control the visibility of the RFQ modal
      isContactPopupVisible: false, // 控制联系方式弹窗显示
      contactPopupTitle: '', // 弹窗标题
      currentContact: '', // 当前联系方式
      currentContactType: '', // 当前联系方式类型
      currentQRCode: '', // 当前二维码
      copySuccess: false, // 复制成功状态
      rfqForm: {
        product: '',
        num: 1,
        email: '',
        company: '',
      },
      quoteForm: {
        name: '',
        num: 1,
        email: '',
      },
      setting: {},
    }
  },
  mounted() {
    this.quoteForm.name = this.product ? this.product : '';
  },
  created() {
    var kf = document.createElement('script');
    kf.async = true;
    kf.src = "https://tb.53kf.com/code/code/b4d1bd6701eb72e48c532431505e97d14/1";
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(kf, s);

    this.getSetting();
  },
  methods: {
  async getSetting() {
    try {
      const response = await api.getSetting();
      this.setting = response.data; // 假设返回的数据在 response.data 中
    } catch (error) {
      console.error('There was an error fetching the products:', error);
    }
  },
  toggleQRCode(type) {
    if (type === 'wechat') {
      this.isWechatQRCodeVisible = !this.isWechatQRCodeVisible;
      if (this.isWechatQRCodeVisible) {
        this.isWhatsappQRCodeVisible = false;
        this.isTelegramQRCodeVisible = false;
        this.isLineQRCodeVisible = false;
      }
    } else if (type === 'whatsapp') {
      this.isWhatsappQRCodeVisible = !this.isWhatsappQRCodeVisible;
      if (this.isWhatsappQRCodeVisible) {
        this.isWechatQRCodeVisible = false;
        this.isTelegramQRCodeVisible = false;
        this.isLineQRCodeVisible = false;
      }
    } else if (type === 'telegram') {
      this.isTelegramQRCodeVisible = !this.isTelegramQRCodeVisible;
      if (this.isTelegramQRCodeVisible) {
        this.isWechatQRCodeVisible = false;
        this.isWhatsappQRCodeVisible = false;
        this.isLineQRCodeVisible = false;
      }
    } else if (type === 'line') {
      this.isLineQRCodeVisible = !this.isLineQRCodeVisible;
      if (this.isLineQRCodeVisible) {
        this.isWechatQRCodeVisible = false;
        this.isWhatsappQRCodeVisible = false;
        this.isTelegramQRCodeVisible = false;
      }
    }
    // Google Analytics 事件
    let conversionId;
    switch (type) {
      case 'wechat':
        conversionId = 'AW-16678313103/U0d3COGyuOEZEI-565A-';
        break;
      case 'whatsapp':
        conversionId = 'AW-16678313103/ncQZCN6yuOEZEI-565A-';
        break;
      case 'telegram':
        conversionId = 'AW-16678313103/TelegramConversionId';
        break;
      case 'line':
        conversionId = 'AW-16678313103/IKr6COSyuOEZEI-565A-';
        break;
      default:
        conversionId = '';
    }
    if (conversionId) {
      console.log('conversionId:', conversionId);
      // gtag('event', 'conversion', { 'send_to': conversionId });
    }
  },
  trackEvent(conversionId) {
    console.log('conversionId:', conversionId);
    // gtag('event', 'conversion', { 'send_to': conversionId });
  },
  scrollToTop() {
    window.scrollTo(0, 0);
  },
  toggleRFQModal() {
    this.quoteForm.name = this.product ? this.product : '';
    this.isRFQModalVisible = !this.isRFQModalVisible;
  },
  async submitRFQ() {
      try {
        const response = await api.offers({
          model: this.rfqForm.product,
          num: this.rfqForm.num,
          email: this.rfqForm.email,
          company: this.rfqForm.company,
          name: '',
        });

        if (response.status === 200 && response.data.code === 200) {
          this.$mMessage.success("We will reply to your offer as soon as possible.");
          this.isRFQModalVisible = false; // 关闭模态框
          this.resetRFQForm(); // 重置表单
        } else {
          this.$mMessage.error("Failed to submit. Please try again later.");
        }
      } catch (error) {
        console.error('Failed to submit RFQ:', error);
        this.$mMessage.error("Failed to submit. Please try again later.");
      }
    },
    resetRFQForm() {
      this.rfqForm = {
        product: '',
        num: 1,
        email: '',
        company: '',
      };
    },
    async submitQuote() {
      if (!this.quoteForm.name || !this.quoteForm.num || !this.quoteForm.email) {
        this.$mMessage.error("Please fill in all required fields.");
        return;
      }
      const myreg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if(!myreg.test(this.quoteForm.email)){
        this.$mMessage.error("email is not valid.");
        return;
      }
      try {
        const data = {
          model: this.quoteForm.name,
          num: this.quoteForm.num,
          email: this.quoteForm.email,
          type: 1
        };
        const response = await api.addFormSubmit(data);
        console.log('Quote submitted successfully:', response.data);
        // 显示成功消息
        this.$mMessage.success("Quote submitted successfully!");
        // 关闭模态框
        this.isRFQModalVisible = false;
        // 重置表单
        this.quoteForm.name = this.product ? this.product : '';
        this.quoteForm.num = 1;
        this.quoteForm.email = '';
      } catch (error) {
        console.error('There was an error submitting the quote:', error);
        // 显示错误消息
        // this.$toast.error("Failed to submit quote. Please try again.");
      }
    },
    handleInput(event) {
      this.quoteForm.name = event.target.value;
    },
    showContactPopup(type, contact) {
      // 先复制联系方式
      this.copyToClipboard(contact);
      
      this.currentContactType = type;
      this.currentContact = contact;
      
      switch(type) {
        case 'whatsapp':
          this.contactPopupTitle = 'WhatsApp';
          this.currentQRCode = 'https://en.icqqg.com/uploads/' + this.setting.whatsapp_qrcode;
          break;
        case 'wechat':
          this.contactPopupTitle = 'WeChat';
          this.currentQRCode = 'https://en.icqqg.com/uploads/' + this.setting.wx_qrcode;
          break;
        case 'telegram':
          this.contactPopupTitle = 'Telegram';
          this.currentQRCode = 'https://en.icqqg.com/uploads/' + this.setting.telegram_qrcode;
          break;
        case 'line':
          this.contactPopupTitle = 'Line';
          this.currentQRCode = 'https://en.icqqg.com/uploads/' + this.setting.line_qrcode;
          break;
        case 'email':
          this.contactPopupTitle = 'Email';
          break;
      }
      
      this.isContactPopupVisible = true;
      
      // 跟踪事件
      let conversionId;
      switch (type) {
        case 'wechat':
          conversionId = 'AW-16678313103/U0d3COGyuOEZEI-565A-';
          break;
        case 'whatsapp':
          conversionId = 'AW-16678313103/ncQZCN6yuOEZEI-565A-';
          break;
        case 'telegram':
          conversionId = 'AW-16678313103/TelegramConversionId';
          break;
        case 'line':
          conversionId = 'AW-16678313103/IKr6COSyuOEZEI-565A-';
          break;
        case 'email':
          conversionId = 'AW-16678313103/ZjJYCNuyuOEZEI-565A-';
          break;
        default:
          conversionId = '';
      }
      if (conversionId) {
        this.trackEvent(conversionId);
      }
    },
    
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
          .catch(err => {
            console.error('Failed to copy: ', err);
            this.fallbackCopyToClipboard(text);
          });
      } else {
        this.fallbackCopyToClipboard(text);
      }
    },
    
    fallbackCopyToClipboard(text) {
      // 兼容不支持clipboard API的浏览器
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';  // 防止影响页面布局
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Failed to copy with fallback: ', err);
      }
      document.body.removeChild(textarea);
    },
    handleContactClick(type) {
      // 判断是否为移动设备
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      
      if (isMobile) {
        // 移动端显示弹窗
        this.showContactPopup(type, this.getContactInfo(type));
      } else {
        // PC端显示侧边的QR码
        this.toggleQRCode(type);
      }
    },
    
    getContactInfo(type) {
      switch(type) {
        case 'whatsapp':
          return this.setting.whatsapp;
        case 'wechat':
          return this.setting.wechat;
        case 'telegram':
          return this.setting.telegram;
        case 'line':
          return this.setting.line;
        default:
          return '';
      }
    },
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.hello {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.modal-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  border-radius: 8px;
  padding: 20px !important;
}

.cb { 
  width: 54px; 
  position: fixed; 
  right: 0; 
  top: 30%; 
  box-shadow: rgba(0,0,0,0.16) 0 0 10px; 
  display: flex; 
  flex-direction: column; 
  z-index: 999; 
  padding-left: 0;
}

.cb .cbItem { 
  height: 70px; 
  cursor: pointer; 
  display: flex; 
  flex-wrap: wrap; 
  align-items: center; 
  justify-content: center; 
  position: relative; 
  background: #329fd7; 
  margin-bottom: 3px;
}

.cb .cbItem:hover { 
  background: #005FCC; 
}

.cb .cbItem .cbTc { 
  position: absolute; 
  right: 0; 
  top: 12px; 
  display: none; 
  transform: translateX(30px); 
  opacity: 0; 
  transition: all ease 0.5s; 
  padding-right: 80px;

  img {
    width: 100%;
  }
}

.cb .cbItem.on .cbTc { 
  display: block; 
  opacity: 1; 
  transform: translateX(0);
}

.cb .cbItem .cbTc .cbTcEr { 
  width: 132px; 
  height: 132px;
}

.cb .cbItem .cbTc .cbTcTel { 
  white-space: pre; 
  padding: 0 15px; 
  line-height: 45px; 
  background: #FFFFFF; 
  border-radius: 5px; 
  box-shadow: rgba(0,0,0,0.15) 0 0 10px; 
  width: fit-content;
}

.cb .cebianItem2 { 
  height: 55px; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  position: relative;
}

.cb .cbItem a { 
  width: 100%;
}

.cb .cbItem span { 
  font-size: 11px; 
  color: #FFF;
}

.slide-img { 
  width: 40px; 
  margin-left: 7px;
}

.form-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  .form-label {
    width: 25%;
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }

  .form-control {
    width: 75%;
    flex-grow: 1;
  }
}

.contact-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  width: 320px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
}

.popup-header {
  padding: 10px;
  text-align: right;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #888;
}

.popup-body {
  padding: 0 20px 20px;
  text-align: center;
}

.qrcode {
  margin: 0 auto 15px;
  width: 150px;
  height: 150px;
}

.qrcode img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.contact-info {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.instruction-text {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
  line-height: 1.4;
}

.extra-text {
  font-size: 14px;
  color: #555;
  margin-bottom: 20px;
}

.know-btn {
  background-color: #4CD964;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 30px;
  font-size: 16px;
  cursor: pointer;
}
</style>
